export const BAD_REQUEST = 422;
export const INTERNAL_SERVER_ERROR = 500;
export const NOT_FOUND_ERROR = 404;
export const POST_SUCCESS_CODE = 201;
export const SUCCESS_CODE = 200;
export const UNAUTHORIZED = 401;
